import React from 'react';
import Logo from '../components/logo';
import styled from '@emotion/styled';
import TymeLink from '../components/link.js';
import {centeredContent, modularScale} from '../design-system/utils';
import theme from '../design-system/theme';
import RoundAppButton from './round-app-button';
import HamburgerButton from '../design-system/icons/js/HamburgerButton';
import CloseButton from '../design-system/icons/js/CloseButton';

export default class SiteHeader extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            this.setState({
                isExpanded: false
            });
        }
    }

    handleHamburgerButtonClick = () => {
        const {isExpanded} = this.state;
        this.setState({
            isExpanded: !isExpanded
        });
    };

    renderNavigationLinks = (location, textResources) => [
        (
            <TymeLink
                key="home"
                to="/"
                className={
                    (location.pathname === '/de/' || location.pathname === '/en/') ?
                        "navigation-link navigation-link-selected": "navigation-link"
                }
            >
                {textResources['index']}
            </TymeLink>
        ),
        (
            <TymeLink
                key="blog"
                to="/blog/"
                className={
                    location.pathname.includes('/blog') ?
                        "navigation-link navigation-link-selected": "navigation-link"
                }
            >
                {textResources['blog']}
            </TymeLink>
        ),
        (
            <TymeLink
                key="help"
                to="/help/"
                className={
                    location.pathname.includes('/help') ?
                        "navigation-link navigation-link-selected": "navigation-link"
                }
            >
                {textResources['help']}
            </TymeLink>
        ),
        (
            <TymeLink
                key="who"
                to="/who-we-are"
                className={
                    location.pathname.includes('/who-we-are') ?
                        "navigation-link navigation-link-selected": "navigation-link"
                }
            >
                {textResources['who']}
            </TymeLink>
        ),
        (
            <TymeLink
                key="pricing"
                to="/pricing/"
                className={
                    location.pathname.includes('/pricing') ?
                        "navigation-link navigation-link-selected": "navigation-link"
                }
            >
                {textResources['pricing']}
            </TymeLink>
        )
    ];

    render() {
        const {location} = this.props;
        const {isExpanded} = this.state;
        const {textResources} = this.props;

        return (
            <StyledHeader isExpanded={isExpanded}>
                <nav className="big-navigation">
                    <div className="logo-link">
                        <TymeLink to="/">
                            <Logo/>
                        </TymeLink>
                    </div>

                    {this.renderNavigationLinks(location, textResources)}

                    <div className="button-container">
                        <div>{/* needed just for animation */}</div>
                        <RoundAppButton className="get-app-button" title={textResources['download']} linkTarget={'/download/'} big={false}/>
                        {isExpanded ? (
                            <CloseButton className="close-button" onClick={this.handleHamburgerButtonClick}/>
                        ) : (
                            <HamburgerButton className="hamburger-button" onClick={this.handleHamburgerButtonClick}/>
                        )}
                    </div>
                </nav>

                <StyledExpandedMenu isExpanded={isExpanded}>
                    <nav className="small-navigation">
                        {this.renderNavigationLinks(location, textResources)}
                    </nav>
                </StyledExpandedMenu>
            </StyledHeader>
        );
    }
}

const easing = 'cubic-bezier(0.165, 0.84, 0.44, 1)';

const StyledHeader = styled('header')`
	> .big-navigation {
		${centeredContent};
		padding-top: 30px;
		padding-bottom: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.navigation-link {
			display: none;

	        @media (min-width: ${theme.breakpoints.desktop}px) {
				display: block;
			}
		}
	}

	a {
		text-decoration: none;
		color: inherit;
	}

    .navigation-link-selected {
        &:before {
            content: '';
            position: absolute;
            bottom: -5px;
            left: -10px;
            right: -10px;
            height: 2px;
            background-color: ${theme.colors.text};
		}
    }

	.navigation-link {
		position: relative;
		font-size: ${modularScale(-0.5)};
		font-weight: 600;
		color: ${theme.colors.text};
	}

    .logo-link {
		box-sizing: border-box;
		flex: 0 0 ${props => (props.isExpanded ? '30px' : '102px')};
		margin: 0;
		line-height: 0;
		padding-right: 20px;
		visibility: ${props => (props.isExpanded ? 'hidden' : 'visible')};
		overflow: hidden;
		transition: flex-basis 0.5s ${easing};
	}

	.button-container {
		width: ${props => (props.isExpanded ? '100%' : '180px')};
		display: flex;
		align-items: center;
		justify-content: space-between;
		transition: width 0.5s ${easing};

		.get-app-button {
			margin: 0 10px;

            @media (min-width: ${theme.breakpoints.tablet}px) {
				margin: 0;
            }
		}

		.hamburger-button,
		.close-button {
			flex: 0 0 auto;
			width: 30px;
			height: 30px;
			position: relative;

            @media (min-width: ${theme.breakpoints.desktop}px) {
			    display: none;
            }
		}
	}
`;

const StyledExpandedMenu = styled('div')`
	height: 0;
	min-height: ${props => (props.isExpanded ? '290px' : 0)};
	overflow: hidden;
	transition: min-height 0.5s ${easing};

	> .small-navigation {
		${centeredContent};
		padding-top: 20px;
		padding-bottom: 40px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.navigation-link {
			margin-bottom: 40px;
		}
	}
`;
